import axios from 'axios';
import apiFactory from './api';

const instance = axios.create();
const makeRequest = (params: any) => instance(params);

const api = apiFactory({
  makeRequest,
});

api.instance = instance;

export default api;
